export const EMOJI_CATEGORY = {
  Recent: "recent",
  SmilesAndPeople: "smilesAndPeople",
  AnimalsAndNature: "animalsAndNature",
  FoodAndDrink: "foodAndDrink",
  Activities: "activities",
  TravelAndPlaces: "travelAndPlaces",
  Objects: "objects",
  Symbols: "symbols",
  Flags: "flags",
  All: "all",
} as const;

export const EMOJI_DATA_CATEGORIES = [
  EMOJI_CATEGORY.SmilesAndPeople,
  EMOJI_CATEGORY.AnimalsAndNature,
  EMOJI_CATEGORY.FoodAndDrink,
  EMOJI_CATEGORY.Activities,
  EMOJI_CATEGORY.TravelAndPlaces,
  EMOJI_CATEGORY.Objects,
  EMOJI_CATEGORY.Symbols,
  EMOJI_CATEGORY.Flags,
] as const;

export const EMOJI_SKIN_TONE = {
  Neutral: "neutral",
  Light: "light_skin",
  MediumLight: "medium_light_skin",
  Medium: "medium_skin",
  MediumDark: "medium_dark_skin",
  Dark: "dark_skin",
} as const;

type EmojiSkinToneValue = (typeof EMOJI_SKIN_TONE)[keyof typeof EMOJI_SKIN_TONE];

export const EMOJI_SKIN_TONE_MODIFIERS: Readonly<Record<EmojiSkinToneValue, string | null>> = {
  [EMOJI_SKIN_TONE.Neutral]: null,
  [EMOJI_SKIN_TONE.Light]: "1f3fb",
  [EMOJI_SKIN_TONE.MediumLight]: "1f3fc",
  [EMOJI_SKIN_TONE.Medium]: "1f3fd",
  [EMOJI_SKIN_TONE.MediumDark]: "1f3fe",
  [EMOJI_SKIN_TONE.Dark]: "1f3ff",
};

export const EMOJI_SKIN_TONES: readonly EmojiSkinToneValue[] = Object.values(EMOJI_SKIN_TONE);
export const EMOJI_SKIN_TONE_SAMPLE_UNICODE = "1f44d";

export const DEFAULT_FAST_SELECT_EMOJIS: readonly string[] = ["1f44d", "1f44f", "1f525", "2665-fe0f", "1f62e", "1f914"];
